import options from './defaultOptions';

export const userFormPreset = {
  validation: {
    custom_фото: options.logo,
    custom_firstname: {
      ...options.username,
      required: true,
    },
    custom_lastname: {
      ...options.username,
      required: true,
    },
    custom_midname: options.username,
    custom_sexint: {},
    custom_должность: options.role,
    custom_мобильный_телефон: {
      required: true,
      ...options.phone,
    },
    custom_login: {
      ...options.email,
      unique: {
        errorText: 'Пользователь с таким логином уже зарегистрирован',
      },
    },
    custom_первичная_консультация_от: {
      positiveNumber: {
        errorText: "Допустимы только числа"
      },
      custom: {
        validator: (value, values) => {
          const from = Number(value);
          const to = Number(values.custom_первичная_консультация_до)

          if (from === 0 || to === 0) return true;

          return from <= to;
        },
        errorText: "Стоимость 'от' должна быть меньше или равна 'до'"
      },
    },
    custom_whatsapp: {
      ...options.phone,
    },
    custom_первичная_консультация_до: {
      positiveNumber: {
        errorText: "Допустимы только числа"
      },
    },
    custom_повторная_консультация_от: {
      positiveNumber: {
        errorText: "Допустимы только числа"
      },
      custom: {
        validator: (value, values) => {
          const from = Number(value);
          const to = Number(values.custom_повторная_консультация_до);

          if (from === 0 || to === 0) return true;

          return Number(from) <= Number(to);
        },
        errorText: "Стоимость 'от' должна быть меньше или равна 'до'"
      },
    },
    custom_повторная_консультация_до: {
      positiveNumber: {
        errorText: "Допустимы только числа"
      },
    },
    custom_сопровождение_от: {
      positiveNumber: {
        errorText: "Допустимы только числа"
      },
      custom: {
        validator: (value, values) => {
          const from = Number(value);
          const to = Number(values.custom_сопровождение_до);

          if (from === 0 || to === 0) return true;

          return Number(from) <= Number(to);
        },
        errorText: "Стоимость 'от' должна быть меньше или равна 'до'"
      },
    },
    custom_сопровождение_до: {
      positiveNumber: {
        errorText: "Допустимы только числа"
      },
    },
  },
};

export const userFormLightPreset = {
  validation: {
    custom_фото: options.logo,
    custom_firstname: {
      ...options.username,
      required: true,
    },
    custom_lastname: {
      ...options.username,
      required: true,
    },
    custom_midname: options.username,
    custom_sexint: {},
    custom_должность: options.role,
    custom_мобильный_телефон: {
      required: true,
      ...options.phone,
    },
    custom_номер_нпа: {
      required: true,
      ...options.npa,
    },
    custom_login: {
      ...options.email,
      unique: {
        errorText: 'Пользователь с таким логином уже зарегистрирован',
      },
    },
  },
}

export const instituteFormPreset = {
  validation: {
    custom_логотип: options.logo,
    custom_название: {
      ...options.agency,
      required: true,
    },
    custom_тип: {},
    custom_филиал: {},
    custom_город: {
      required: true,
    },
    custom_улица: {
      ...options.street,
      required: true,
    },
    custom_дом: {
      ...options.house,
      required: true,
    },
    custom_корпус: options.casehouse,
//    custom_телефон: options.phone,
    custom_эл_почта: {
      ...options.email,
      required: false,
    },
  },
};
